export function getCookie(key: string): string | undefined {
  const result = `; ${document.cookie}`.match(`;\\s*${key}=([^;]+)`);
  return result ? result.pop() : '';
}

export function setCookie(key: string, value: string, days = 1): void {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expiryDate = date.toUTCString();
  document.cookie = `${key}=${value}; expires=${expiryDate}; path=/`;
}
